/**
 *
 * @author Wang Jianchao(tinyking)
 * @version 1.0
 * @since 2020/8/19
 */

export class Application {
  constructor(public name: string) {}
}
